<style scoped lang="scss">
  .en-title .c-title small{
    margin-top: 10px;
  } 
  @media screen and (max-width: 640px){
    .wrap-tec .c-title{
      padding: 20px 0 20px !important;
      font-size: 20px !important;
    }
  }
</style>
<template>
  <div class="en-title">
    <div class="c-title">{{title}}<small v-if="enTitle">{{enTitle}}</small></div>
  </div>
</template>

<script>
export default {
  name: 'en-title',
  props:{
    title: {
      type: String
    },
    enTitle: {
      type: String
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/EnTitle.vue